import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as e } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const o = e((a, m) => /* @__PURE__ */ s.jsx(
  i,
  {
    ref: m,
    ...a,
    image: (r) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...r,
        children: [
          /* @__PURE__ */ s.jsx(
            "mask",
            {
              id: "mask0_2974_3588",
              width: 16,
              height: 16,
              x: 0,
              y: 0,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ s.jsx(
                "path",
                {
                  fill: "currentColor",
                  d: "M7.97 0C6.88 0 6 .88 6 1.97s.88 1.97 1.97 1.97 1.97-.88 1.97-1.97S9.06 0 7.97 0m0 2.44a.47.47 0 1 1-.001-.939.47.47 0 0 1 .001.939M7.97 6.03C6.88 6.03 6 6.91 6 8s.88 1.97 1.97 1.97S9.94 9.09 9.94 8s-.88-1.97-1.97-1.97m0 2.44a.47.47 0 1 1-.001-.939.47.47 0 0 1 .001.939M7.97 12.06c-1.09 0-1.97.88-1.97 1.97S6.88 16 7.97 16s1.97-.88 1.97-1.97-.88-1.97-1.97-1.97m0 2.44a.47.47 0 1 1-.001-.939.47.47 0 0 1 .001.939M1.97 0C.88 0 0 .88 0 1.97s.88 1.97 1.97 1.97 1.97-.88 1.97-1.97S3.06 0 1.97 0m0 2.44a.47.47 0 1 1-.001-.939.47.47 0 0 1 .001.939M1.97 6.03C.88 6.03 0 6.91 0 8s.88 1.97 1.97 1.97S3.94 9.09 3.94 8s-.88-1.97-1.97-1.97m0 2.44a.47.47 0 1 1-.001-.939.47.47 0 0 1 .001.939M1.97 12.06c-1.09 0-1.97.88-1.97 1.97S.88 16 1.97 16s1.97-.88 1.97-1.97-.88-1.97-1.97-1.97m0 2.44a.47.47 0 1 1-.001-.939.47.47 0 0 1 .001.939M13.97 3.94c1.09 0 1.97-.88 1.97-1.97S15.06 0 13.97 0 12 .88 12 1.97s.88 1.97 1.97 1.97m0-2.44a.47.47 0 1 1 .001.939.47.47 0 0 1-.001-.939M13.97 6.03C12.88 6.03 12 6.91 12 8s.88 1.97 1.97 1.97 1.97-.88 1.97-1.97-.88-1.97-1.97-1.97m0 2.44a.47.47 0 1 1-.001-.939.47.47 0 0 1 .001.939M13.97 12.06c-1.09 0-1.97.88-1.97 1.97S12.88 16 13.97 16s1.97-.88 1.97-1.97-.88-1.97-1.97-1.97m0 2.44a.47.47 0 1 1-.001-.939.47.47 0 0 1 .001.939"
                }
              )
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_3588)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) })
        ]
      }
    )
  }
));
o.displayName = "AgencyGridIcon";
export {
  o as AgencyGridIcon,
  o as default
};
//# sourceMappingURL=index.js.map
